import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { DataBagService } from 'src/app/common/data-bag.service';
import { InfoboxService } from 'src/app/common/infobox/infobox.service';
import { OrganizationService } from '../organization.service';
@Component({
	selector: 'app-organization-data-download',
	templateUrl: './organization-data-download.component.html',
	styleUrls: ['./organization-data-download.component.css'],
})
export class OrganizationDataDownloadComponent {
	constructor(
		private readonly bag: DataBagService,
		public service: OrganizationService,
		private readonly infobox: InfoboxService,
		private readonly dialogRef: MatDialogRef<any>,
	) {}

	uploadOrganizationData(data): any {
		data.trim();
		this.bag.get(`/nip/${data}/`, (result, error) => {
			if (!!error) {
				return;
			}
			this.service.organizationData.nip = result[0].Nip;
			this.service.organizationData.regon = result[0].Regon;
			this.service.organizationData.name = result[0].Nazwa;
			this.dialogRef.close(result);
		});
	}
}
